import React from "react";
import { ClipLoader } from "react-spinners";

const SpinnerLoader = ({ text = "Loading..." }) => {
  return (
    <div style={styles.container}>
      <ClipLoader color="#007bff" size={40} />
      <p style={styles.text}>{text}</p>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "80vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    marginTop: "16px",
    fontSize: "1.2rem",
    fontWeight: "500",
    color: "#007bff",
  },
};

export default SpinnerLoader;
